const EmployeeTypologies = Object.freeze({
    DIPENDENTE: "employees",
	FATTORINO: "drivers"
})

export default EmployeeTypologies
